module.exports = __webpack_public_path__ + "static/media/cover-unavaliable-1.c8719904.png";